<template>
  <div class="home-echarts-wrap" :style="{ width, height, marginBottom }">
    <div class="home-echarts-header" style="padding: 10px 24px 10px 24px;height: auto">
      <h3 class="home-echarts-header__title">{{ title }}</h3>
    </div>
    <div style="flex: 1; overflow:auto;display: flex;padding:0 24px 8px 24px">
      <cos-table
        :columns="listColumns"
        :needPage="false"
        :dataSource="tableData"
        :serial="false"
        rowKey="employeeNo"
        tableId="regionTargetCompletionTable"
        :dynamicColumnSetting="false"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'employeeName'">
            <a-tooltip>
              <template #title>{{ text || '--' }}</template>
              <span class="employeeName">{{ text || '--' }}</span>
            </a-tooltip>
          </template>
          <template v-if="column.dataIndex?.[0] === 'data' && column.dataIndex?.[1] === 'momRate'">
            <span >
              {{ text || '--' }}
              <span v-html="imageByCompare(record.data?.salesAmount, record.data?.lastSalesAmount)"></span>
            </span>
          </template>
          <template v-if="column.dataIndex?.[0] === 'data' && column.dataIndex?.[1] === 'oldMomRate'">
            <span >
              {{ text || '--' }}
              <span v-html="imageByCompare(record.data?.oldSalesAmount, record.data?.lastOldSalesAmount)"></span>
            </span>
          </template>
        </template>
      </cos-table>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, PropType, reactive, ref, watch } from 'vue'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import { getRegionTargetCompletion } from '@/api/gucangSales/regionDataBoard'
import dayjs from 'dayjs'
import riseImage from '@/assets/rise.png'
import declineImage from '@/assets/decline.png'

interface ApiModel {
  salesAmount?: number, // 当月新客收入
  lastSalesAmount?: number, // 上月新客收入
  momInc?: number, // 新客环比增量
  momRate?: string, // 新客环比上月%
  salesAmountTotal?: number, // 当月总收入
  lastSalesAmountTotal?: number, // 上月总收入
  oldSalesAmount?: number, // 当月老客收入
  lastOldSalesAmount?: number, // 上月老客收入
  oldMomInc?: number, // 老客环比上月增量
  oldMomRate?: string, // 老客环比上月%
}

interface ItemModel {
  employeeName?: string // 员工名称
  employeeNo?: string, // 员工工号
  data?: ApiModel
}

interface QueryFormType {
  customerRegionEmployeeNoList?: string[]
  startDay?: string
  endDay?: string
}

const props = defineProps({
  title: {
    type: String as PropType<string>,
    default: '目标完成情况'
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  formState: {
    type: Object as PropType<Object>
  }
})
const listColumns = computed(() => {
  return [
    {
      title: '业务员',
      dataIndex: 'employeeName'
    },
    {
      title: '当月新客收入',
      dataIndex: ['data', 'salesAmount']
    },
    {
      title: '环比上月增量',
      dataIndex: ['data', 'momInc']
    },
    {
      title: '环比上月%',
      dataIndex: ['data', 'momRate']
    },
    {
      title: '当月老客收入',
      dataIndex: ['data', 'oldSalesAmount']
    },
    {
      title: '环比上月增量',
      dataIndex: ['data', 'oldMomInc']
    },
    {
      title: '环比上月%',
      dataIndex: ['data', 'oldMomRate']
    }
  ]
})
const tableData = ref<ItemModel[]>([])
onMounted(() => {
  getData()
})
watch(() => props.formState, (val) => {
  queryForm.customerRegionEmployeeNoList = props?.formState?.customerRegionEmployeeNoList || []
  queryForm.startDay = props?.formState?.startDay || dayjs().startOf('month').format('YYYY/MM/DD')
  queryForm.endDay = props?.formState?.endDay || dayjs().endOf('month').format('YYYY/MM/DD')
  getData()
})
const queryForm = reactive<QueryFormType>({
  startDay: props?.formState?.startDay || dayjs().startOf('month').format('YYYY/MM/DD'),
  endDay: props?.formState?.endDay || dayjs().endOf('month').format('YYYY/MM/DD'),
  customerRegionEmployeeNoList: props?.formState?.customerRegionEmployeeNoList || []
})
const getData = () => {
  getRegionTargetCompletion(queryForm).then((res) => {
    const salesAmountList = res.data as unknown as ApiModel[]
    const transferredData: any[] = []
    props.formState?.region?.deptScopeInfo.forEach((employee: any) => {
      if (employee) {
        transferredData.push({
          employeeName: employee.employeeName,
          employeeNo: employee.employeeNo,
          data: salesAmountList?.find((item) => {
            return item.employeeNo === employee.employeeNo
          })
        })
      }
    })
    tableData.value = transferredData
  }).finally(() => {
  })
}
const imageByCompare = (num1: number, num2: number) => {
  if (num1 > num2) {
    return '<img src="' + riseImage + '" class="icon icon-right" alt="" />'
  } else if (num1 < num2) {
    return '<img src="' + declineImage + '" class="icon icon-right" alt="" />'
  } else {
    return ''
  }
}
</script>
<script lang="ts">
export default {
  name: 'RegionTargetCompletionList'
}
</script>
<style scoped lang="scss">
.employeeName {
  color: $Primary;
}
</style>
